import { render, staticRenderFns } from "./SocietiesKicker.vue?vue&type=template&id=46a720c4"
import script from "./SocietiesKicker.vue?vue&type=script&lang=js"
export * from "./SocietiesKicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports